export const companyRouteNames = [
  'companyActivity', 'companyActivity2', 'allOpportunities', 'myOpportunitiesRequests',
  'companyGallery', 'companyGalleryAlbum', 'companyGalleryMyPhotos',
  'myOpportunitiesVolunteerActivity', 'myOpportunitiesDonations',
  'employeeOpportunityCreate', 'employeeTemplateOpportunityCreate',
  'companyMarketplace', 'companyNonprofit', 'resourcesPage',
  // rsvpRoutes
  'companyOpportunity', 'companyOpportunityVolunteers', 'companyOpportunityFeedback', 'companyOpportunityPhotos',
  // companyImpactRoutes
  'companyImpact', 'companyImpactDetail',
  // companyAdminDashboardRoutes
  'companyEmployees', 'companyHoursManagement', 'companyOpportunityRequests', 'companyEvents', 'companyEventFeedback',
  // companySettingsRoutes
  'companySettingsGeneralSettings', 'companySettingsAdministration', 'companySettingsDepartments',
  'companySettingsPolling', 'companySettingsSlack', 'companySlackAuth',
  'companySettingsMicrosoftTeams', 'companySettingsDonations',
  // settingsRoutes
  'settings', 'settingsProfile', 'settingsContactInformation',
  'settingsNotificationPreferences', 'settingsCausePreferences', 'settingsSecuritySettings',
]
